import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Toast {
  id: string;
  message: string;
  type: 'success' | 'error' | 'info' | 'warning';
  duration?: number;
}

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private _toasts = new BehaviorSubject<Toast[]>([]);
  readonly toasts$ = this._toasts.asObservable();

  show(message: string, type: Toast['type'] = 'info', duration = 4000): void {
    const id = crypto.randomUUID();
    const toast: Toast = { id, message, type, duration };
    this._toasts.next([...this._toasts.value, toast]);

    if (duration > 0) {
      setTimeout(() => this.dismiss(id), duration);
    }
  }

  dismiss(id: string): void {
    this._toasts.next(this._toasts.value.filter(t => t.id !== id));
  }

  success(message: string): void  { this.show(message, 'success'); }
  error(message: string): void    { this.show(message, 'error'); }
  warning(message: string): void  { this.show(message, 'warning'); }
  info(message: string): void     { this.show(message, 'info'); }
}
